angular.module('cfn').factory('cfnGridRenderer', cfnGridRenderer);

cfnGridRenderer.$inject = [
  '$compile',
  '$dialog',
  'cfnGridDefaults',
  'companyFinanceService',
  'unitConverter',
  'userSettingsService'
];
function cfnGridRenderer(
  $compile,
  $dialog,
  cfnGridDefaults,
  companyFinanceService,
  unitConverter,
  userSettingsService
) {
  'use strict';
  var service = {};

  service.init = function(scope, element, attrs) {
    var si = {
        tpl: {},
        headerTpl: {},
        contentTpl: {},
        printableTpl: {}
      },
      scope = scope;

    si.customRendererByType = {
      boolean: function(col, data) {
        return (
          "<input type='checkbox' " +
          "ng-model='" +
          data +
          "' " +
          "class='cfnGridCheckbox'>"
        );
      },
      readonlyboolean: function(col, data) {
        // actually usually every field in our current
        // grid is readonly be default. Sadly some
        // places seem to use the boolean flag and
        // change ability.
        // because of this we created a readOnlyBoolean
        // type.
        return (
          "<input type='checkbox' " +
          "onclick='return false;' " +
          "ng-model='" +
          data +
          "' " +
          "class='cfnGridCheckbox'>"
        );
      },
      html: function(col, data) {
        return '<span ng-bind-html="' + data + '">' + '</span>';
      },
      innerhtml: function(col, data) {
        return col.innerHtml;
      },
      dragger: function(col, data, scope) {
        //scope.containsDragNDropColumn = true; //TODO: this should never have worked,..!? scope is contentHtml, why was this necessary?
        return (
          '<div class="gea-item-dragger" ' +
          'gea-item-dragger="item">' +
          '<i class="fa fa-bars"></i>' +
          '<div>' +
          '{{scope.columns[0]|json}}' +
          '</div>' +
          (col.geaDragItemTemplate ? col.geaDragItemTemplate : '') +
          '</div>'
        );
      },
      area: function(col, data, scope) {
        if (data) {
          var userUnitEnum = userSettingsService.getAreaUnitEnum();

          return (
            '{{' +
            data +
            "|convertUnit:'AREAL_HA':'" +
            userUnitEnum +
            "'|number:" +
            unitConverter.unitDefaultDecimals(userUnitEnum) +
            '}} ' +
            userSettingsService.getAreaUnit()
          );
        } else {
          return '';
        }
      }
    };

    si.tpl.getColHtml = function(i) {
      var col = scope.columns[i];
      return {
        headerHtml: si.headerTpl.getColHeaderHtml(i, col),
        headerFilterHtml: si.headerTpl.getColFilterHtml(i, col),
        contentHtml: si.contentTpl.getColTdHtml(i, col)
      };
    };

    si.contentTpl.getColTdHtml = function(i, col) {
      var colId = 'columns[' + i + ']';
      var ret = {
        contentHtml: ''
      };

      scope.columnsByName[col.name] = col;

      // hoverstart, hoverend
      var hoverHtmlCol = '';
      if (scope.hoverstart()) {
        hoverHtmlCol +=
          ' ng-mouseenter="domouseenter(\'' + col.name + '\', item, $event)"';
      }

      if (scope.hoverend()) {
        hoverHtmlCol +=
          ' ng-mouseleave="domouseleave(\'' + col.name + '\', item, $event)"';
      }

      var styleClass = !!col.align ? 'cfnGrid-align-' + col.align : '';
      var cellClass = col.cellclassname ? col.cellclassname : '';

      ret.contentHtml +=
        '<td ng-dblclick=\'dodblclick("' +
        col.name +
        '",item)\'' +
        ' ng-click=\'doclick("' +
        col.name +
        '",item, $event)\' ' +
        hoverHtmlCol +
        " ng-show='" +
        colId +
        ".visible' " +
        " class='type_" +
        col.type +
        ' ' +
        col.cellclassname +
        ' ' +
        styleClass +
        "'>";

      // Handle fixed coloumns:
      // 1. set fixed height for table-cells if there are fixed and variable columns
      // 2. turn off automatic cell-width calculation for variable coloumns
      var ngstyle,
        displaysize = parseInt(col.displaysize);

      if (scope.fixedcols) {
        if (i >= scope.fixedcols) {
          ngstyle =
            '{width: ' +
            displaysize * cfnGridDefaults.constants.nonFixedWidthFactor +
            ', height: ' +
            scope.fixedcolheight +
            '}';
        } else {
          ngstyle =
            '{width:' +
            colId +
            '.dWidth, height: ' +
            scope.fixedcolheight +
            '}';
        }
      } else {
        ngstyle = '{width:' + colId + '.dWidth}';
      }

      ret.contentHtml +=
        '<div ' + " class='cfnGC' " + " ng-style='" + ngstyle + "'>";

      var filter = col.filter;

      // Apply default filter for column types
      if (scope.$cfnGridFiltering.angularFilterByColumnType[col.type]) {
        filter = scope.$cfnGridFiltering.angularFilterByColumnType[col.type](
          col
        );
      }

      var data = '';

      var subElement = col.name;
      if (col.value) subElement = col.value;

      //select coltype
      if (col.enum) {
        data = 'item.' + subElement + "|enum:'" + col.enum + "'";
      } else if (col.unitName) {
        data = null;

        var unit;
        if (col.type !== 'currency') {
          unit = 'item.' + subElement + '_' + col.unitName;
        } else {
          unit = "'" + companyFinanceService.getCurrencyUnit() + "'";
        }
        var digits = col.typeparam;

        ret.contentHtml +=
          '<span ng-show="item.' +
          subElement +
          '!=undefined && item.' +
          subElement +
          '!=null ">' +
          '{{item.' +
          subElement +
          '*(' +
          unit +
          "|enumUnitFactor:'" +
          col.replaceByEnum +
          "')|number:" +
          digits +
          '}}' +
          ' {{' +
          unit +
          "|replaceByEnum:'" +
          col.replaceByEnum +
          "'}}" +
          '</span>';
      } else if (col.replaceByEnum) {
        data =
          'item.' + subElement + "|replaceByEnum:'" + col.replaceByEnum + "'";
      } else if (filter) {
        data = 'item.' + subElement + '|' + filter + '';
      } else {
        data += 'item.' + subElement;
      }

      var renderer = col.renderer();
      if (renderer) {
        scope.renderers[subElement] = renderer;
        col.renderFunc = renderer;
        col.type = 'html';
        data +=
          '|cfnGridRenderer:' +
          colId +
          '.renderFunc:$index:' +
          colId +
          '.name:item';
      }

      // Convert string to boolean, default is true
      col.sortable = col.sortable !== 'false';

      var coltype = col.type.toLowerCase();
      //Custom Renderer
      if (data !== null) {
        if (si.customRendererByType[coltype]) {
          ret.contentHtml += si.customRendererByType[coltype](
            col,
            data,
            ret.contentHtml
          );
        } else {
          ret.contentHtml += '{{' + data + '}}';
        }
      }

      ret.contentHtml += '</div>';
      ret.contentHtml += '</td>';

      return ret.contentHtml;
    };

    si.headerTpl.getHelperFunction = function(functionType, col) {
      if (functionType === 'filterOpen') {
        return function() {
          var tempData = {
            type: 'day',
            date: new Date()
          };
          if (scope.view.filters[col.name]) {
            tempData = $.extend(true, tempData, scope.view.filters[col.name]);
          }

          var modalInstance = $dialog
            .dialog({
              resolve: {
                data: function() {
                  return {
                    filter: tempData
                  };
                }
              }
            })
            .open(
              require('../input/time-and-date/dateFilterSelectorPopup.html'),
              'dateFilterSelectorPopupController'
            )
            .then(function(exitResult) {
              if (exitResult) {
                if (exitResult.result === 'ok') {
                  if (exitResult.filter.type === 'none') {
                    scope.view.filters[col.name] = null;
                  } else {
                    scope.view.filters[col.name] = exitResult.filter;
                  }
                  //this works like a blur effect
                  scope.onFilterBlur(col.name);
                }
              }
            });
        };
      } else {
        console.debug('Not implemented helper function: ' + functionType);
      }
    };

    si.headerTpl.getColHeaderHtml = function(i, col) {
      var colId = 'columns[' + i + ']';

      // Handle fixed coloumns:
      // 1. set fixed height for table-cells if there are fixed and variable columns
      // 2. turn off automatic cell-width calculation for variable coloumns
      var ngstyle,
        displaysize = parseInt(col.displaysize);
      if (scope.fixedcols) {
        if (i >= scope.fixedcols) {
          ngstyle =
            '{width: ' +
            displaysize * cfnGridDefaults.constants.nonFixedWidthFactor +
            '}';
        } else {
          ngstyle = '{width:' + colId + '.dWidth}';
        }
      } else {
        ngstyle = '{width:' + colId + '.dWidth}';
      }

      var thClassAdd = '';
      if (col.sortable === 'false') {
        thClassAdd += ' not-sortable';
      }

      var sortIcons =
        "<img class='sort-img-old' src='img/sort_down_14.png' ng-if='" +
        colId +
        '.sorted && ' +
        colId +
        ".sortedReversed'/>" +
        "<img class='sort-img-old' src='img/sort_up_14.png' ng-if='" +
        colId +
        '.sorted && !' +
        colId +
        ".sortedReversed'/>" +
        "<img class='sort-img' src='img/sort_notactive.png' ng-if='!" +
        colId +
        ".sorted'/>" +
        "<img class='sort-img' src='img/sort_up.png' ng-if='" +
        colId +
        '.sorted && !' +
        colId +
        ".sortedReversed'/>" +
        "<img class='sort-img' src='img/sort_down.png' ng-if='" +
        colId +
        '.sorted && ' +
        colId +
        ".sortedReversed'/>";

      var clickHandler = " ng-click='headerClicked(" + colId + ")'";
      var content = '{{' + colId + '.title}}';
      var btnHideColActive =
        col.showBtnToHideColumn === 'true' ? 'btn-hide-col-active' : '';

      var output =
        "<th class='no-select col" +
        i +
        thClassAdd +
        "'" +
        " ng-class='[" +
        colId +
        '.cellclassname,' +
        '"sorted-" + ' +
        colId +
        ".sorted]'" +
        " title='" +
        content +
        "'" +
        " ng-show='" +
        colId +
        ".visible'" +
        clickHandler +
        '>' +
        "<div ng-style='" +
        ngstyle +
        "'>" +
        sortIcons +
        "<span class='title " +
        btnHideColActive +
        "'>" +
        si.headerTpl.getSpanHeaderHideColBtn(i, col) +
        content +
        '</span>' +
        si.headerTpl.getSpanHeaderSecondHtml(i, col) +
        '</div>' +
        '</th> ';

      return output;
    };

    /**
     * Returns HTML for the hide-column-button
     * @param {int} i
     * @param {Object} col
     */
    si.headerTpl.getSpanHeaderHideColBtn = function(i, col) {
      if (col.showBtnToHideColumn === 'true') {
        return "<span class='btn-hide-col'></span>";
      } else {
        return '';
      }
    };

    /**
     * Returns HTML for the second header
     * @param {int} i
     * @param {Object} col
     */
    si.headerTpl.getSpanHeaderSecondHtml = function(i, col) {
      var colId = 'columns[' + i + ']';

      var output =
        "<span class='second-title'>" +
        '{{' +
        colId +
        '.secondTitle}}' +
        '</span>';
      return output;
    };

    scope.onFilterBlur = function(colName) {
      var col = scope.columnsByName[colName];
      if (col.onFilterBlurFn()) {
        col.onFilterBlurFn()(col, scope.view.filters[colName]);
      }
    };
    si.headerTpl.getColFilterHtml = function(i, col) {
      var colId = 'columns[' + i + ']',
        onFilterBlurStr = 'ng-blur="onFilterBlur(\'' + col.name + '\')" ',
        filterDeleteBtn =
          '<div ' +
          'class="filterDeleteBtn">' +
          '<button ng-if="view.filters[\'' +
          col.name +
          "'].length>0||view.filters['" +
          col.name +
          '\']" ' +
          'class="btn imgOnly" ng-click="view.filters[\'' +
          col.name +
          "']=null; $event.stopPropagation();onFilterBlur('" +
          col.name +
          '\')">' +
          '<img src="img/bicons/black/remove.png"/>' +
          '</button>' +
          '</div>',
        filterOb = "view.filters['" + col.name + "']",
        headerFilterContent = '',
        headerFilterHtml = '',
        headerFilterAdditional = '',
        filtertype;

      filtertype = {
        boolShowAll:
          col.filtertypeOverride &&
          col.filtertypeOverride.toLowerCase() === 'boolean-showall',
        bool:
          (col.type &&
            col.type.toLowerCase().indexOf('bool') != -1 &&
            col.filterable !== 'false') ||
          (col.filtertypeOverride &&
            col.filtertypeOverride.toLowerCase() === 'boolean' &&
            col.filterable !== 'false'),
        enum: !!col.enum,
        date:
          (col.filterSelector === 'DateSelector' &&
            col.filterable !== 'false') ||
          (col.filterSelector === 'DateTimeSelector' &&
            col.filterable !== 'false'),
        variety: col.filterSelector === 'VarietySelector',
        none:
          col.filterable === 'false' ||
          ((col.type === 'innerHtml' && !col.hasCustomFilterFn()) ||
            (col.filtertypeOverride &&
              col.filtertypeOverride.toLowerCase() !== '')) ||
          col.type === 'dragger'
      };

      switch (true) {
        case filtertype.boolShowAll:
          filterDeleteBtn = ''; // no filter-remove button
          headerFilterContent +=
            '<span ' +
            'class="cursor-pointer" ' +
            '">' +
            '<input name="' +
            col.name +
            '_filter" ' +
            'style="margin:0;margin-right:3px;" ' +
            'ng-model="' +
            filterOb +
            '" ' +
            onFilterBlurStr +
            'type="checkbox">' +
            "{{'fe.common.all' | i18n : 'Alle'}}";
          '</span>';
          break;

          headerFilterContent +=
            "<span class='filterBox' " +
            "style='height: 20px;min-height: 20px!important;display:block;' " +
            'ng-class="{filtered:(' +
            filterOb +
            ')}">';

          headerFilterContent +=
            "<span class='inlineEdit' ng-click=\"" +
            filterOb +
            "='true'\">" +
            '<input name="' +
            col.name +
            '_filter" ' +
            'style="margin:0;margin-right:3px;" ' +
            'type="radio" ' +
            'ng-checked="' +
            filterOb +
            "=='true'\" " +
            onFilterBlurStr +
            'ng-value="true">' +
            "{{'fe.common.filter.true' | translate :'Ja'}}" +
            '</span>';

          headerFilterContent +=
            "<span class='inlineEdit' ng-click=\"" +
            filterOb +
            "='false'\">" +
            '<input   name="' +
            col.name +
            '_filter" ' +
            ' style="margin:0;margin-right:3px;" ' +
            ' type="radio" ' +
            ' ng-checked="' +
            filterOb +
            "=='false'\" " +
            onFilterBlurStr +
            ' ng-value="false">' +
            "{{'fe.common.filter.false' | translate :'Nein'}}" +
            '</span>';

          headerFilterContent += '</span>';
          break;

        case filtertype.enum:
          filterDeleteBtn = ''; // no remove button for
          // enums;
          //should we add onFilterBlur to this input?
          headerFilterContent +=
            "<cfn-input-enum optional='true' " +
            ' model="' +
            filterOb +
            '" ' +
            ' enum-name="' +
            col.enum +
            '" ' +
            ' ng-class="{filtered:' +
            filterOb +
            '.length>0}" ' +
            ' options="columnsByName[\'' +
            col.name +
            '\'].enumOptions" ' +
            " style='height: 20px;min-height: 20px;padding: 0px;' " +
            ' class="input-block-level">' +
            '</cfn-input-enum>';

          break;

        case filtertype.date:
          var click = "ng-click='" + colId + ".filterOpen();' ";

          headerFilterContent +=
            "<span class='filterBox' " +
            click +
            ' ' +
            "style='height: 20px;min-height: 20px!important;display:block;' " +
            'ng-class="{filtered:(view.filters[\'' +
            col.name +
            '\'])}">' +
            ' <span ng-if="view.filters[\'' +
            col.name +
            "'].type=='day'\">" +
            "{{view.filters['" +
            col.name +
            "'].date|date:'mediumDate'}}" +
            ' </span>' +
            ' <span ng-if="view.filters[\'' +
            col.name +
            "'].type=='timeFrame'\">" +
            "{{view.filters['" +
            col.name +
            "'].startDate|date:'mediumDate'}} - {{view.filters['" +
            col.name +
            "'].endDate|date:'mediumDate'}}" +
            ' </span>' +
            '</span>';

          col.filterOpen = si.headerTpl.getHelperFunction('filterOpen', col);
          break;

        case filtertype.variety:
          filterDeleteBtn = ''; // no remove button
          headerFilterContent +=
            '<select ng-model="view.filters[\'' +
            col.name +
            '\']" ' +
            'ng-options="opt for opt in view.filterArrays[\'' +
            col.name +
            '\']" ' +
            'ng-change="onFilterBlur(\'' +
            col.name +
            '\')" ' +
            "style='height: 20px; min-height: 20px; width: 100%; padding: 0px;'>" +
            '<option value=""></option>' +
            '</select>';
          break;

        case filtertype.none:
          headerFilterContent += '';
          // No filtering
          break;

        default:
          headerFilterContent +=
            '<input ng-model="view.filters[\'' +
            col.name +
            '\']" ' +
            'ng-class="{filtered:view.filters[\'' +
            col.name +
            '\'].length>0}" ' +
            onFilterBlurStr +
            "style='height: 20px;min-height: 20px;' " +
            "type='text' class='input-block-level'/>";
      }

      if (headerFilterContent !== '') {
        headerFilterContent = filterDeleteBtn + headerFilterContent;
      }

      var ngstyle,
        displaysize = parseInt(col.displaysize);
      if (scope.fixedcols) {
        if (i >= scope.fixedcols) {
          ngstyle =
            'width: ' +
            displaysize * cfnGridDefaults.constants.nonFixedWidthFactor +
            ',';
        } else {
          ngstyle = 'width:' + colId + '.dWidth,';
        }
      } else {
        ngstyle = 'width:' + colId + '.dWidth, ';
      }

      headerFilterHtml +=
        '<td ' +
        headerFilterAdditional +
        "class='col" +
        i +
        ' filterCol ' +
        col.cellclassname +
        "' " +
        "ng-show='" +
        colId +
        ".visible' " +
        "ng-style='{" +
        ngstyle +
        'height:headerFilterHeight,"max-height_":headerFilterHeight+"px"}\'>' +
        headerFilterContent +
        '</td>';

      return headerFilterHtml;
    };

    si.contentTpl.getRowClasses = function() {
      // TODO: hier rowclasses

      app.startPerfTimer('cfnGrid Classes');
      var rClasses = {};
      if (scope.rowclasses) {
        $.each(scope.rowclasses, function(k, v) {
          // allow custom rowclasses
          // of the format
          // class:expression
          if (v.indexOf(':') != -1) {
            rClasses[v.substr(0, v.indexOf(':'))] = v.substr(
              v.indexOf(':') + 1,
              v.length
            );
          } else cfnGridCompatibility.convertRowClasses(v, rClasses);
        });
      }
      // add default selection and inactive and invalid
      // states
      if (!rClasses.selected) rClasses.selected = 'item.$cfngrid_selected';
      if (!rClasses.elementHidden)
        rClasses.elementHidden = 'item.$cfngrid_hidden';
      if (!rClasses.elementInactive)
        rClasses.elementInactive = 'item.$cfngrid_inactive';
      if (!rClasses.elementInvalid)
        rClasses.elementInvalid = 'item.$cfngrid_invalid';

      var rowClassStr = '';
      $.each(rClasses, function(k, v) {
        if (rowClassStr) rowClassStr += ', ';
        rowClassStr += k + ': ' + v;
      });
      return rowClassStr;
    };

    si.headerTpl.getCheckboxHtml = function(htmlObject) {
      // prepend checkboxes if configured

      scope.doCheckAll = function() {
        var allSelected = scope.allSelected;
        // scope.clearSelection(); //
        // scope.allSelected will be set to false
        // here
        scope.allSelected = allSelected;
        if (allSelected) {
          $.each(scope.filterdData, function(idx, item) {
            if (!item.$cfngrid_inactive) {
              item.$cfngrid_selected = true;
              scope.selected[item.id] = item;
            }
          });
        } else {
          $.each(scope.filterdData, function(idx, item) {
            item.$cfngrid_selected = false;
            if (scope.selected[item.id]) {
              delete scope.selected[item.id];
            }
          });
        }
        scope.updateSelectionView();
        if (scope.selectionchange()) {
          scope.selectionchange()(scope.selected);
        }
      }; // doCheckAll

      return {
        thCode: "<th class='cfnGridCheckboxCol'>" + '</th>',
        thFilterCode:
          "<td class='cfnGridCheckboxCol'>" +
          "<input type='checkbox' " +
          "ng-model='allSelected' " +
          "class='cfnGridCheckbox' " +
          "ng-change='doCheckAll()'>" +
          '</td>'
      };
    };

    si.headerTpl.getOuterHtml = function(htmlObject) {
      //header
      var nonfixedCols, fixedCols;

      //filter
      var thCode = htmlObject.headerHtml,
        thCodeUnfixed = htmlObject.headerUnfixed,
        thSecondCodeUnfixed = htmlObject.headerSecondUnfixed,
        thFilterCode = htmlObject.headerFilterHtml,
        thFilterCodeNonfixed = htmlObject.headerFilterUnfixed;

      var thPrintCode = '';
      if (scope.printable == 'true') {
        thPrintCode = si.printableTpl.getPrintBtn();
      }

      var thCheckboxHtml;
      if (scope.checkboxselectable === 'true') {
        thCheckboxHtml = si.headerTpl.getCheckboxHtml();
        thCode = thCheckboxHtml.thCode + thCode;
        thFilterCode = thCheckboxHtml.thFilterCode + thFilterCode;
      }

      var mainHeader = '<tr>' + thCode + thPrintCode + '</tr>';

      fixedCols =
        "<table class='cfnGridHeader' >" +
        '<thead>' +
        mainHeader +
        '<tr>' +
        thFilterCode +
        '</tr>' +
        '</thead>' +
        '</table>';

      var nonFixedHeader = '<tr>' + thCodeUnfixed + '</tr>';
      if (scope.showSecondTitle === 'true') {
        nonFixedHeader +=
          '<tr class="second-title">' + thSecondCodeUnfixed + '</tr>';
      }

      nonfixedCols =
        "<div class='cfn-grid-header-container' style='width: 50%; overflow-x: auto; overflow: hidden; position: absolute; left: 50%; top: 0;'>" +
        "<table class='cfnGridHeader' cfn-synchronize-vert-scroll-slave='lkj'>" +
        '<thead>' +
        nonFixedHeader +
        '<tr>' +
        thFilterCodeNonfixed +
        '</tr>' +
        '</thead>' +
        '</table>' +
        '</div>';

      return fixedCols + nonfixedCols;
    };

    si.contentTpl.getOuterHtml = function(htmlObject) {
      // hoverstart, hoverend
      var hoverHtml = '';
      if (scope.hoverstart())
        hoverHtml += " ng-mouseenter='domouseenter(null, item, $event)'";
      if (scope.hoverend())
        hoverHtml += " ng-mouseleave='domouseleave(null, item, $event)'";

      var uncompiledHTML =
        '<table ' +
        " class='cfnGrid fixed' " +
        " style='float: left;' " +
        ' ng-class=\'{ "unselectable" : containsDragNDropColumn}\'>' +
        '<tbody>' +
        "<tr  ng-repeat='item in viewData'" +
        hoverHtml +
        " ng-class='{" +
        htmlObject.rowClasses +
        "}'>" +
        htmlObject.contentHtml +
        '</tr>' +
        '</tbody>' +
        '</table>';

      var uncompiledHTML2 = '';
      if (htmlObject.contentHtmlUnfixed) {
        uncompiledHTML2 =
          "<div style='width: 50%; overflow-x: auto; overflow: auto; position: absolute; left: 50%;'>" +
          "<table class='cfnGrid nonfixed' " +
          "ng-class='{ \"unselectable\" : containsDragNDropColumn}' cfn-synchronize-vert-scroll-master='lkj'>" +
          '<tbody>' +
          "<tr ng-repeat='item in viewData'" +
          hoverHtml +
          " ng-class='{" +
          htmlObject.rowClasses +
          "}'>" +
          htmlObject.contentHtmlUnfixed +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '</div>';
      }

      return uncompiledHTML + uncompiledHTML2;
    };

    si.printableTpl.getOuterHtml = function(htmlObject) {
      var thPrintCode = '';
      if (scope.printable == 'true') {
        thPrintCode = si.printableTpl.getPrintBtn();
      }

      return (
        "<table class='cfnGrid'>" +
        '<thead>' +
        htmlObject.headerHtml +
        '</thead>' +
        '<tbody>' +
        "<tr ng-repeat='item in filterdData' ng-class='{" +
        htmlObject.rowClasses +
        "}'>" +
        htmlObject.contentHtml +
        '</tr>' +
        '</tbody>' +
        '</table>'
      );
    };

    si.printableTpl.getPrintBtn = function() {
      return (
        '<td>' +
        '<button ' +
        "class='btn imgOnly' " +
        "style='height:19px;width:18px;margin-top: -2px;' " +
        "ng-click='print()'>" +
        "<img style='margin-top:-2px ' src='img/bicons/black/print.png'/>" +
        '</button>' +
        '</td>'
      );
    };

    si.buildFixedRowHtml = function() {
      var colgroup = '',
        headerHtml = '',
        headerSecondHtml = '',
        headerHtmlUnfixed = '',
        headerSecondHtmlUnfixed = '',
        headerFilterHtml = '',
        headerFilterUnfixed = '',
        contentHtml = '',
        contentHtmlUnfixed = '';

      scope.renderers = {};
      scope.columnsByName = {};

      // hoverstart, hoverend
      var hoverHtmlColCheck = '';
      if (scope.hoverstart())
        hoverHtmlColCheck +=
          ' ng-mouseenter="domouseenter(\'CHECK\', item, $event)"';
      if (scope.hoverend())
        hoverHtmlColCheck +=
          ' ng-mouseleave="domouseleave(\'CHECK\', item, $event)"';

      if (scope.checkboxselectable === 'true') {
        contentHtml =
          "<td class='cfnGridCheckboxCol'" +
          hoverHtmlColCheck +
          '>' +
          "<input type='checkbox' " +
          "ng-model='item.$cfngrid_selected' " +
          "ng-disabled='item.$cfngrid_inactive' " +
          "class='cfnGridCheckbox' " +
          "ng-change='docheckclick(item)'>" +
          '</td>' +
          contentHtml;
      }

      scope.containsDragNDropColumn = false;

      $.each(scope.columns, function(i, col) {
        var builtColHtml = si.tpl.getColHtml(i, col);

        if (i < scope.fixedcols || !scope.fixedcols) {
          contentHtml += builtColHtml.contentHtml;
          headerHtml += builtColHtml.headerHtml;
          headerFilterHtml += builtColHtml.headerFilterHtml;
        }

        if (i >= scope.fixedcols) {
          contentHtmlUnfixed += builtColHtml.contentHtml;
          headerHtmlUnfixed += builtColHtml.headerHtml;
          headerFilterUnfixed += builtColHtml.headerFilterHtml;
        }
      });

      if (scope.deleteable === 'true') {
        var deleteBtn =
          '<button class="btn imgOnly" ng-click="onDeleteClick(item)">' +
          '<img src="img/bicons/black/remove.png"/>' +
          '</button>';

        contentHtml +=
          " <td class='cfnGridDeleteCol'" +
          hoverHtmlColCheck +
          '>' +
          deleteBtn +
          '</td>';
      }

      var rowClasses = si.contentTpl.getRowClasses();

      return {
        contentHtml: contentHtml,
        contentHtmlUnfixed: contentHtmlUnfixed,
        headerHtml: headerHtml,
        headerSecondHtml: headerSecondHtml,
        headerUnfixed: headerHtmlUnfixed,
        headerSecondUnfixed: headerSecondHtmlUnfixed,
        headerFilterHtml: headerFilterHtml,
        headerFilterUnfixed: headerFilterUnfixed,
        rowClasses: rowClasses
      };
    };

    si.compileHtml = function(htmlObject) {
      //if (!scope.columnsByName) return "";
      //content
      var compiledContent = $compile(si.contentTpl.getOuterHtml(htmlObject))(
        scope
      );

      //header
      var unCompiledHeader = si.headerTpl.getOuterHtml(htmlObject);
      var compiledHeader = $compile(unCompiledHeader)(scope);

      //printable
      var unCompiledPrintable;
      var compiledPrintable;
      if (scope.printable == 'true') {
        compiledPrintable = $compile(si.printableTpl.getOuterHtml(htmlObject))(
          scope
        );
      }

      return {
        header: compiledHeader,
        table: compiledContent,
        printableTable: compiledPrintable
      };
    };

    return si;
  };

  return service;
}
